function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M19.3894 16L31.7508 28.3614C32.0831 28.6937 32.0831 29.0592 31.7508 29.4579L29.4579 31.7508C29.0592 32.0831 28.6937 32.0831 28.3614 31.7508L26.2679 29.5576L16 19.3894L3.63863 31.7508C3.30633 32.0831 2.94081 32.0831 2.54206 31.7508L0.249221 29.4579C-0.0830737 29.0592 -0.0830737 28.6937 0.249221 28.3614L12.6106 16L0.249221 3.63863C-0.0830737 3.30633 -0.0830737 2.94081 0.249221 2.54206L2.54206 0.249221C2.94081 -0.0830737 3.30633 -0.0830737 3.63863 0.249221L16 12.6106L28.3614 0.249221C28.6937 -0.0830737 29.0592 -0.0830737 29.4579 0.249221L31.7508 2.54206C32.0831 2.94081 32.0831 3.30633 31.7508 3.63863L29.5576 5.73209L19.3894 16Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.79b5fd29e68edece1b2df8c61812a7cf.svg";
export { ForwardRef as ReactComponent };